import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=32cc8a21&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=ts"
export * from "./Certificates.vue?vue&type=script&lang=ts"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=32cc8a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc8a21",
  null
  
)

export default component.exports